// Microsoft Entra ID (Azure AD) auth configuration.
// Reuses the same app registration values as the ITS project.
// Provide these via NEXT_PUBLIC_ environment variables (see .env.local).

export const msalConfig = {
  auth: {
    clientId: process.env.NEXT_PUBLIC_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.NEXT_PUBLIC_AZURE_TENANT_ID}`,
    redirectUri: process.env.NEXT_PUBLIC_REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
}

export const loginRequest = {
  scopes: [process.env.NEXT_PUBLIC_SCOPE],
}
